<template>
  <section
    v-if="render"
    :class="$style.root"
    :data-within-modal="withinModal ? '' : null"
  >
    <template
      v-for="block in blocks"
      :key="block?.id"
    >
      <CoreBlocksTextComponent
        v-if="block?.__component === 'blocks.text'"
        :block="block"
        :withinModal="withinModal"
      />
      <CoreBlocksImagesComponent
        v-if="block?.__component === 'blocks.images'"
        :block="block"
        :withinModal="withinModal"
      />
    </template>
  </section>
</template>

<script setup>
const props = defineProps({
  blocks: {
    type: [Object, Array]
  },
  withinModal: {
    type: Boolean,
    default: false
  }
})

const blocks = computed(() => {
  return props?.blocks?.filter(i => {
    const localizedData = i18nGetLocalizedData(i)
    if (i?.__component === 'blocks.text') {
      return localizedData?.current_locale || localizedData?.i18n_richtext_en
    } else if (i?.__component === 'blocks.images') {
      return localizedData?.images?.data?.length > 0
    } else {
      return false
    }
  })
})

const render = computed(() => {
  return blocks?.value?.length > 0
})
</script>

<style module>
.root {
  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 3);
}
</style>
